import styled from 'styled-components';
import ChatMessage from './ChatMessage';
import { colorSchema } from 'utils/style';

export default styled(ChatMessage)`
  .chat-message {
    display: flex;
    flex-direction: column;

    &__content {
      font-size: 1.4rem;
      line-height: 1.43;
      padding: 0.8rem 1.6rem;
      a {
        color: ${colorSchema('white')};
        text-decoration: underline;
        word-wrap: break-word;
      }
    }

    &__time {
      color: ${colorSchema('grey500')};
      font-size: 1.2rem;
      margin-top: 0.5rem;
    }

    &__container {
      margin-bottom: 1.6rem;
      width: 80%;
    }

    &--agent {
      .chat-message__content {
        background-color: ${colorSchema('primary100')};
        border-radius: 0 8px 8px 8px;
      }

      .chat-message__time {
        text-align: left;
      }
    }

    &--user {
      align-items: flex-end;

      .chat-message__content {
        background-color: ${colorSchema('primary500')};
        border-radius: 8px 0 8px 8px;
        color: ${colorSchema('white')};
      }

      .chat-message__time {
        text-align: right;
      }
    }
  }
`;
